import { render } from "./AddLeads.vue?vue&type=template&id=04d16cf4"
import script from "./AddLeads.vue?vue&type=script&lang=js"
export * from "./AddLeads.vue?vue&type=script&lang=js"

import "./AddLeads.vue?vue&type=style&index=0&id=04d16cf4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__